export const TOAST_MESSAGES = {
  ADMIN: {
    CREATE_SUCCESS: "Admin created successfully",
    UPDATE_SUCCESS: "Admin updated successfully",
    ADMIN_ERROR: "Error while saving admin",
  },
  CATEGORY: {
    CREATE_SUCCESS: "Category created successfully",
    UPDATE_SUCCESS: "Category updated successfully",
    CATEGORY_ERROR: "Error while saving category",
  },
};
